import { Box, BoxProps } from "@mui/material";

import { EnvHelper } from "@/common/helpers/env";
import { useRenderCount } from "@/common/hooks/render/useRenderCount";

import InfoTile from "../Form/Display/InfoTile";
import AppTypography from "../Text/AppTypography";

interface Props {
  isPositionFixed?: boolean;
  description?: string;
  sx?: BoxProps["sx"];
}

/** Tracks and displays number of renders. */
export function DevRenderCount({ isPositionFixed, description, sx }: Props) {
  const { renderCount } = useRenderCount();

  if (!EnvHelper.isLocalhostAny) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "fit-content",
        ...(isPositionFixed
          ? {
              position: "absolute",
              top: 100,
              right: 60,
              zIndex: (th) => th.zIndex.tooltip,
              boxShadow: (th) => th.shadows[6],
            }
          : {}),
        ...sx,
      }}
    >
      <InfoTile
        sx={{ backgroundColor: (th) => th.palette.highlight.main }}
        label={
          <AppTypography component='span' variant='subtitle1'>
            Render count: {renderCount}
          </AppTypography>
        }
        isEmpty={!description}
      >
        <Box>
          {description && (
            <AppTypography component='span' variant='body2'>
              {description}
            </AppTypography>
          )}
        </Box>
      </InfoTile>
    </Box>
  );
}
